<template>
  <v-card>
    <h1 class="text-pagename text-xs-center">Rider dashboard</h1>
    <v-container fluid grid-list-lg class="pt-0">
      <v-layout justify-center align-center wrap>
        <!-- <v-flex md5 sm8 xs12>
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 9 : 2}`"
              router-link
              :to="'/weserve_admin_login/control/'+ $route.params.province +'/food/customermanage'"
              @click="$store.commit('backOffice/showMenu','weserve')"
            >
              <v-layout class="mt-2">
                <v-flex xs4 class="py-0 pr-0">
                  <div class="d-flex flex-icon-btn"><v-icon large  color="black">people</v-icon></div>
                </v-flex>
                <v-flex xs8>
                  <div class="text-count">80</div>
                  <div class="text-dashboard">Rider in system</div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-hover>
        </v-flex>

        <v-flex md5 sm8 xs12>
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 9 : 2}`"
              router-link
              :to="'/weserve_admin_login/control/' + $route.params.province + '/storeandproduct/storemanage'"
              @click="$store.commit('backOffice/showMenu','storeandproduct')"
            >
            <v-layout class="mt-2">
              <v-flex xs4 class="py-0 pr-0">
                <div class="d-flex flex-icon-btn"><v-icon large  color="black">assessment</v-icon></div>
              </v-flex>
              <v-flex xs8>
                <div class="text-count">1,000,000</div>
                <div class="text-dashboard">Totle profit</div>
              </v-flex>
            </v-layout>
            </v-card>
          </v-hover>
        </v-flex>

         <v-flex md5 sm8 xs12>
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 9 : 2}`"
              router-link
              :to="'/weserve_admin_login/control/' + $route.params.province + '/messenger/addon'"
              @click="$store.commit('backOffice/showMenu','messenger')"
            >
            <v-layout class="mt-2">
              <v-flex xs4 class="py-0 pr-0">
                <div class="d-flex flex-icon-btn"><v-icon large  color="black">money</v-icon></div>
              </v-flex>
              <v-flex xs8>
                <div class="text-count">570,000</div>
                <div class="text-dashboard">Money</div>
              </v-flex>
            </v-layout>
            </v-card>
          </v-hover>
        </v-flex>-->

        <v-flex md5 sm8 xs12 v-for="item in items" :key="item.title">
          <v-hover>
            <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 9 : 2}`" router-link>
              <v-layout class="mt-2">
                <v-flex xs4 class="py-0 pr-0">
                  <div class="d-flex flex-icon-btn">
                    <v-icon large color="black">{{ item.icon }}</v-icon>
                  </div>
                </v-flex>
                <v-flex xs8>
                  <div class="text-count">{{ item.count }}</div>
                  <div class="text-dashboard">{{ item.title }}</div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-hover>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          icon: "people",
          count: "80",
          title: "Rider in system"
        },
        {
          icon: "assessment",
          count: "1,000,000",
          title: "Totle profit"
        },
        {
          icon: "money",
          count: "1,800,000",
          title: "Money"
        },
        {
          icon: "credit_card",
          count: "700,000",
          title: "Credit"
        }
      ]
    };
  },
  computed: {},
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Rider",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/rider/riderinhouse"
        // href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/riderdashboard'
      },
      {
        text: "Rider management",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style scoped>
.text-count {
  font-size: 2.5rem;
  color: #767676;
  margin-top: 5px;
  padding-top: 10px;
  text-align: center;
}
.text-dashboard {
  font-size: 18px;
  color: #767676;
  /* margin-top: 5px; */
  padding: 0 10px 10px 10px;
  text-align: center;
}
.flex-icon-btn {
  background-color: #ffd600;
  height: 100%;
  border-radius: 3px 0px 0px 3px;
}
</style>